import { isMissingRequiredSelection } from './is-missing-required-selection.js';

const getSelectedNode = (selectedFacets, treeLevelVariants, facetConfig, currentNode)=>{
    if (isMissingRequiredSelection(selectedFacets, treeLevelVariants, facetConfig, currentNode)) {
        return undefined;
    } else {
        return currentNode;
    }
};

export { getSelectedNode };
//# sourceMappingURL=get-selected-node.js.map
